var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavBar',{attrs:{"active":_vm.activeMenyIndex,"create_router_to":{name: 'addToStopList', params: {org: _vm.$route.params.org} },"create_text":_vm.$t('StopLists.AddCompany'),"items":_vm.list,"loading":_vm.loading,"types":_vm.types,"unload":""},on:{"filterItems":_vm.filterByTypes}})
}
var staticRenderFns = []

export { render, staticRenderFns }